import { twMerge } from "tailwind-merge";
import { Check } from "lucide-react";

type Props = {
  isDisabled: boolean;
};

export function CheckCircle({ isDisabled }: Props) {
  return (
    <div
      className={twMerge(
        "ml-2 rounded-full  p-2",
        isDisabled ? "border-brand-300" : "bg-brand-600"
      )}
    >
      <Check
        className={twMerge(
          "w-4 h-4",
          isDisabled ? "text-brand-400" : "text-brand-50"
        )}
        strokeWidth={3}
      />
    </div>
  );
}

export default CheckCircle;
